import { useHistory, useParams } from "react-router";
import { ApiLoadingSpinner, BreadCrumb, Header } from "@funcional/react-ui";
import { useUser } from "@sso/users/hooks";
import { useUpdateUser, useReplaceUserProfiles } from "@sso/users/hooks";
import UserUpdateForm from "@sso/users/components/UserUpdateForm";
import { IGraphQLError } from "@common/contracts";
import { useState } from "react";

export default function EditUserPage() {
  const [graphQLErrors, setGraphQLErrors] = useState<IGraphQLError[]>([]);
  let { uuid }: { uuid: string } = useParams();

  const {
    status: fetchStatus,
    data: fetchData,
    error: fetchError,
  } = useUser(uuid);

  const updateUser = useUpdateUser(fetchData);
  const replaceUserProfiles = useReplaceUserProfiles();

  const isFormLoading =
    updateUser.isLoading ||
    replaceUserProfiles.isLoading ||
    (updateUser.isSuccess && replaceUserProfiles.isSuccess);

  const history = useHistory();

  const onSubmit = async (variables: any) => {
    try {
      const updatedRecord = await updateUser.mutateAsync(variables);
      if (updatedRecord) {
        await replaceUserProfiles.mutateAsync({
          uuid,
          profiles: variables.profiles.map(({ role, identity }) => ({
            role,
            identities: identity && identity !== "" ? [identity] : null,
          })),
        });
      }
      return history.push(`/sso/users/${updatedRecord.uuid}`);
    } catch (error: any) {
      console.error(error);
      if (error.response.errors) {
        return setGraphQLErrors(error.response.errors || []);
      }
      setGraphQLErrors([
        {
          message:
            "Não foi possível salvar o registro, tente novamente mais tarde.",
        },
      ]);
    }
  };

  return (
    <>
      <Header title="Editar Usuário" backTo={`/sso/users/${uuid}`}>
        <BreadCrumb
          marginBottom={0}
          items={[
            { path: "/sso/users", label: "Usuários" },
            {
              path: `/sso/users/${uuid}`,
              label: uuid,
            },
            { label: "Editar" },
          ]}
        />
      </Header>

      <div>
        {fetchStatus === "loading" ? (
          <ApiLoadingSpinner />
        ) : fetchStatus === "error" ? (
          <span>Erro: {JSON.stringify(fetchError)}</span>
        ) : fetchData ? (
          <UserUpdateForm
            isLoading={isFormLoading}
            onSubmit={onSubmit}
            defaults={fetchData}
            graphQLErrors={graphQLErrors}
          />
        ) : (
          <div>Usuário não encontrado.</div>
        )}
      </div>
    </>
  );
}
